<div class="container bannerSection boxShadow">
    <button mat-icon-button aria-label="close dialog" style="float: right;" mat-dialog-close disableRipple>
        <mat-icon>close</mat-icon>
    </button>
    <div class="col-md-12 col-sm-12 col-xs-12 nopad">
        <div class="col-md-12 col-sm-12 col-xs-12 nopad bannerContainer">
            <video class="videoSize" controls autoplay>
                <source [src]="videosUrl" type="video/mp4">
                Your browser does not support the video tag.
            </video>
        </div>
    </div>
</div>